<template>
  <div>
    <header>
      <button :class="customHeader" class="flex items-center w-full" @click.stop="toggle" type="button" :aria-expanded="active ? 'true' : 'false'">
        <slot name="headerRight" />
        <div class="flex-none ml-auto" v-if="hasContent">
            <slot name="headerLeft" />
        </div>
        <div class="flex-none ml-auto" v-else>
            <base-button-icon :focusable="false" :class="{'rotate-180':active}" class="transform transition-transform duration-150" type="primary-phantom" name="chevrondown" 
              :titleIcon="active ? 'Contraer submenú' : 'Desplegar submenú'" 
              :ariaLabel="active ? 'Contraer submenú' : 'Desplegar submenú'" 
              />
        </div>
      </button>
    </header>
    <transition
      name="collapsible"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <section v-if="active" class="overflow-hidden">
        <div :class="customContent">
            <slot name="content" />
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import BaseButtonIcon from './BaseButtonIcon.vue'
export default {
  components: { BaseButtonIcon },
  name: 'base-collapsible',
  props: {
    customHeader: {
      type: String,
      default: ''
    },
    customContent: {
      type: String,
      default: ''
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      active: false
    }
  },
  mounted () {
    if (this.defaultOpen) this.toggle()
  },
  computed: {
    hasContent: function () {
      return this.$scopedSlots.headerLeft
    }
  },
  methods: {
    toggle () {
      this.active = !this.active
    },
    startTransition (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-enter-active,
.collapsible-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.collapsible-enter,
.collapsible-leave-to {
  height: 0 !important;
}
</style>
